<template>
  <div class="animated fadeIn upload-prk">
    <b-row v-if="!showUploadFrm">
      <b-col>
        <b-card>
          <div slot="header">
            Hasil Migrasi Data Angsuran
            <div class="card-header-actions">
              <button
                class="btn btn-primary mr-1"
                @click="savemigrationdata()"
                :disabled="!saveEnabled"
              >
                <i class="fa fa-save"></i> Save
              </button>
              <button
                class="btn btn-primary mr-1"
                @click="
                  saveEnabled
                    ? (confirmCancel = !confirmCancel)
                    : handleCancel()
                "
              >
                <i class="fa fa-close"></i> {{ $t("cancel") }}
              </button>
            </div>
          </div>
          <b-card no-body>
            <template v-slot:header v-if="filterShow == 'Hide'">
              <b-row>
                <b-col lg="3">
                  <b-input-group size="sm" class="mt-1">
                    <b-input-group-prepend>
                      <span class="pt-1 mr-1">FILTER</span>
                    </b-input-group-prepend>
                    <b-form-input
                      v-model="filter"
                      type="search"
                      id="filterInput"
                      placeholder="Type to Search"
                    ></b-form-input>
                    <b-input-group-append>
                      <b-button :disabled="!filter" @click="clearFilter"
                        >Clear</b-button
                      >
                    </b-input-group-append>
                  </b-input-group>
                  <b-form-checkbox
                    v-model="filterShow"
                    value="Hide"
                    unchecked-value="Show"
                    switch
                  >
                    <b>{{ filterShow }}</b> Filter
                  </b-form-checkbox>
                </b-col>
                <b-col lg="9">
                  <b-form-group
                    label="FILTER ON :"
                    label-cols-sm="1"
                    description="Leave all unchecked to filter on all data"
                    class="mb-0"
                  >
                    <b-form-checkbox-group v-model="filterOn" class="mt-1">
                      <b-form-checkbox value="rekonsil"
                        >Rekon Status</b-form-checkbox
                      >
                      <b-form-checkbox value="uraian1"
                        >Description Sub Modul</b-form-checkbox
                      >
                      <b-form-checkbox value="uraian2"
                        >Description GL</b-form-checkbox
                      >
                      <b-form-checkbox value="nilai1"
                        >Value Sub Modul</b-form-checkbox
                      >
                      <b-form-checkbox value="nilai2">Value GL</b-form-checkbox>
                    </b-form-checkbox-group>
                  </b-form-group>
                </b-col>
              </b-row>
            </template>
            <b-table
              class="mb-0 text-nowrap"
              ref="tableangsuran"
              sticky-header="600px"
              outlined
              responsive
              striped
              hover
              style="font-size: smaller"
              :items="data"
              :fields="tblLcy.fields"
              :current-page="tblLcy.page"
              :per-page="tblLcy.limit"
              :sort-by.sync="tblLcy.sortBy"
              :sort-desc.sync="tblLcy.sortDesc"
              :filter="filter"
              :filterIncludedFields="filterOn"
              @filtered="onFiltered"
              :tbody-tr-class="rowClass"
            >
              <template v-slot:thead-top="data">
                <b-tr>
                  <b-th colspan="13">
                    <span class="sr-only">&nbsp;</span>
                  </b-th>
                  <b-th variant="success" colspan="3" class="text-center"
                    >AKUMULASI PAYMENT / SETTLEMENT</b-th
                  >
                  <b-th variant="warning" colspan="3" class="text-center"
                    >SALDO/SISA</b-th
                  >
                </b-tr>
              </template>
              <template v-slot:head(error_text)="data">
            <span
              ><i class="fa fa-exclamation-circle" aria-hidden="true" v-b-tooltip.hover
                title="Baris bermasalah akan ditandai dengan warna kuning"></i
            ></span>
          </template>
          <template v-slot:cell(error_text)="data">
            <span v-if="(data.item.error_text || '') != ''">
              <i
                class="fa fa-exclamation-circle"
                aria-hidden="true"
                v-b-tooltip.hover
                :title="data.item.error_text"
              ></i>
            </span>
          </template>
              <template v-slot:cell(no_kontrak)="data">
                <span
                  v-if="
                    data.item._cellVariants &&
                    data.item._cellVariants.no_kontrak == 'danger'
                  "
                  v-b-tooltip.hover
                  title="No kontrak tidak ada di DATABASE"
                  >{{ data.item.no_kontrak }}</span
                >
                <span v-else>{{ data.item.no_kontrak }}</span>
              </template>
              <template v-slot:cell(tgl_jttempo)="data">
                <span v-if="data.item.tgl_jttempo">{{
                  data.item.tgl_jttempo | moment("DD-MMM-YYYY")
                }}</span>
              </template>
              <template v-slot:cell(nilai_pokok)="data">{{
                data.item.nilai_pokok | numFormat("0,0.00")
              }}</template>
              <template v-slot:cell(nilai_bunga)="data">{{
                data.item.nilai_bunga | numFormat("0,0.00")
              }}</template>
              <template v-slot:cell(angsuran)="data">{{
                data.item.angsuran | numFormat("0,0.00")
              }}</template>
              <template v-slot:cell(akum_pokok)="data">{{
                data.item.akum_pokok | numFormat("0,0.00")
              }}</template>
              <template v-slot:cell(sisa_pokok)="data">{{
                data.item.sisa_pokok | numFormat("0,0.00")
              }}</template>
              <template v-slot:cell(total_denda)="data">{{
                data.item.total_denda | numFormat("0,0.00")
              }}</template>
              <template v-slot:cell(settle_pokok)="data">{{
                data.item.settle_pokok | numFormat("0,0.00")
              }}</template>
              <template v-slot:cell(settle_bunga)="data">{{
                data.item.settle_bunga | numFormat("0,0.00")
              }}</template>
              <template v-slot:cell(settle_denda)="data">{{
                data.item.settle_denda | numFormat("0,0.00")
              }}</template>
              <template v-slot:cell(outstand_pokok)="data">{{
                data.item.outstand_pokok | numFormat("0,0.00")
              }}</template>
              <template v-slot:cell(outstand_bunga)="data">{{
                data.item.outstand_bunga | numFormat("0,0.00")
              }}</template>
              <template v-slot:cell(outstand_denda)="data">{{
                data.item.outstand_denda | numFormat("0,0.00")
              }}</template>

              <template v-slot:custom-foot>
                <b-tr>
                  <b-td colspan="12">
                    <h6 class="text-right">Total:</h6>
                  </b-td>
                  <b-td>
                    <h6 class="text-right">
                      {{ subtotal.sum_settle_pokok | numFormat("0,0.00") }}
                    </h6>
                  </b-td>
                  <b-td>
                    <h6 class="text-right">
                      {{ subtotal.sum_settle_bunga | numFormat("0,0.00") }}
                    </h6>
                  </b-td>
                  <b-td>
                    <h6 class="text-right">
                      {{ subtotal.sum_settle_denda | numFormat("0,0.00") }}
                    </h6>
                  </b-td>
                  <b-td>
                    <h6 class="text-right">
                      {{ subtotal.sum_outstand_pokok | numFormat("0,0.00") }}
                    </h6>
                  </b-td>
                  <b-td>
                    <h6 class="text-right">
                      {{ subtotal.sum_outstand_bunga | numFormat("0,0.00") }}
                    </h6>
                  </b-td>
                  <b-td>
                    <h6 class="text-right">
                      {{ subtotal.sum_outstand_denda | numFormat("0,0.00") }}
                    </h6>
                  </b-td>
                </b-tr>
              </template>
            </b-table>
            <b-row class="mt-2">
              <!-- <b-col lg="8">
            <b-row>
              <b-col cols="6">
                <b-form-checkbox
                  v-model="filterShow"
                  value="Hide"
                  unchecked-value="Show"
                  switch
                  class="ml-2"
                >
                  <b>{{ filterShow }}</b> Filter
                </b-form-checkbox>
                Showing {{(tblLcy.page - 1) * tblLcy.limit + 1}}
                    to
                    <span
                      v-if="((tblLcy.page * tblLcy.limit)>tblLcy.total)"
                    >{{tblLcy.total}}</span>
                    <span v-else>{{tblLcy.page * tblLcy.limit}}</span>
                    of {{tblLcy.total}} entries,
              </b-col>
              <b-col cols="6">
                <div style="display: flex;margin:0;padding:0;">
                  <div style="margin:0;padding:5px;width:500px; text-align:right;">
                    Showing {{(tblLcy.page - 1) * tblLcy.limit + 1}}
                    to
                    <span
                      v-if="((tblLcy.page * tblLcy.limit)>tblLcy.total)"
                    >{{tblLcy.total}}</span>
                    <span v-else>{{tblLcy.page * tblLcy.limit}}</span>
                    of {{tblLcy.total}} entries,
                    <span
                      class="mr-1"
                    >limit per page :</span>
                    <select v-model="tblLcy.limit" style="width:60px;">
                      <option>10</option>
                      <option>15</option>
                      <option>20</option>
                      <option>25</option>
                      <option>30</option>
                      <option>40</option>
                      <option>50</option>
                      <option>60</option>
                      <option>70</option>
                      <option>80</option>
                      <option>90</option>
                    </select>
                  </div>
                  <div>
                    <b-pagination
                      class="ml-1"
                      align="left"
                      :total-rows="tblLcy.total"
                      :per-page="tblLcy.limit"
                      v-model="tblLcy.page"
                    ></b-pagination>
                  </div>
                </div>
              </b-col>
            </b-row>
          </b-col> -->
              <b-col cols="4">
                <!-- <b-form-checkbox
                  v-model="filterShow"
                  value="Hide"
                  unchecked-value="Show"
                  switch
                  class="ml-2"
                >
                  <b>{{ filterShow }}</b> Filter
                </b-form-checkbox> -->
                Showing {{ ((tblLcy.page - 1) * tblLcy.limit + 1) | numFormat }}
                to
                <span v-if="tblLcy.page * tblLcy.limit > tblLcy.total">{{
                  tblLcy.total | numFormat
                }}</span>
                <span v-else>{{
                  (tblLcy.page * tblLcy.limit) | numFormat
                }}</span>
                of {{ tblLcy.total | numFormat }} entries,
              </b-col>
              <b-col cols="4">
                <div style="display: flex; margin: 0; padding: 0">
                  <div
                    style="
                      margin: 0;
                      padding: 5px;
                      width: 500px;
                      text-align: center;
                    "
                  >
                    <!-- Showing {{(tblLcy.page - 1) * tblLcy.limit + 1}}
                    to
                    <span
                      v-if="((tblLcy.page * tblLcy.limit)>tblLcy.total)"
                    >{{tblLcy.total}}</span>
                    <span v-else>{{tblLcy.page * tblLcy.limit}}</span>
                    of {{tblLcy.total}} entries, -->
                    <span class="mr-1">limit per page :</span>
                    <select v-model="tblLcy.limit" style="width: 60px">
                      <option>10</option>
                      <option>15</option>
                      <option>20</option>
                      <option>25</option>
                      <option>30</option>
                      <option>40</option>
                      <option>50</option>
                      <option>60</option>
                      <option>70</option>
                      <option>80</option>
                      <option>90</option>
                    </select>
                  </div>
                  <!-- <div>
                    <b-pagination
                      class="ml-1"
                      align="left"
                      :total-rows="tblLcy.total"
                      :per-page="tblLcy.limit"
                      v-model="tblLcy.page"
                    ></b-pagination>
                  </div> -->
                </div>
              </b-col>
              <b-col lg="4">
                <!-- <b-row align-h="right">
              <b-col md="5">
                <b-form-group label="Total Sisa Pokok">
                  <my-number
                    class="form-control text-right"
                    v-model="subtotal.totalModul"
                    :precision="2"
                    disabled
                  ></my-number>
                </b-form-group>
              </b-col>
              <b-col md="5">
                <b-form-group label="Total Sisa Bunga">
                  <my-number
                    class="form-control text-right"
                    v-model="subtotal.totalGl"
                    :precision="2"
                    disabled
                  ></my-number>
                </b-form-group>
              </b-col>
            </b-row> -->
                <div>
                  <b-pagination
                    class="ml-1"
                    align="right"
                    :total-rows="tblLcy.total"
                    :per-page="tblLcy.limit"
                    v-model="tblLcy.page"
                  ></b-pagination>
                </div>
              </b-col>
            </b-row>
            <b-row align-h="end">
          <!-- <b-col cols="4">One of two columns</b-col> -->
          <b-col cols="4">
            <!-- <b-card> -->
              <b-input-group>
                <b-input-group-prepend>
                  <label>Jumlah Data Error</label>
                </b-input-group-prepend>
                <span class="form-control-static py-2">: {{subtotal.error}} Record</span>
              </b-input-group>
            <!-- </b-card> -->
          </b-col>
        </b-row>
            <b-row v-if="showProgressMigration">
              <b-col>
                <b-alert show variant="warning"
                  >Status :
                  <strong>{{ progressMigrationAngsTemp.status }}</strong>
                  <!-- ,Data yang
              berhasil dibaca
              <strong>{{ progressMigrationAngsTemp.value | numFormat }}</strong>
              baris -->
                </b-alert>
              </b-col>
            </b-row>
          </b-card>
        </b-card>
      </b-col>
    </b-row>

    <b-row align-h="center" v-else>
      <b-col md="8">
        <b-card>
          <div slot="header">
            Migrasi Data Angsuran
            <div class="card-header-actions">
              <div>
                <b-button class="btn-normal alert mb-2 mr-2" @click="close">
                  <i class="fa fa-times"></i> Close
                </b-button>
              </div>
            </div>
          </div>
          <div v-if="!showProgressMigration">
            <b-input-group>
              <b-input-group-prepend>
                <label>Choose *.XLSX file</label>
              </b-input-group-prepend>
              <b-form-file
                v-model="fileXlsx"
                :state="!$v.fileXlsx.$error"
                placeholder="Choose a XLSX file..."
                drop-placeholder="Drop XLSX file here..."
              ></b-form-file>
            </b-input-group>
            <b-row no-gutters>
              <b-col lg="6">
                <b-input-group>
                  <b-input-group-prepend>
                    <label>Nama SHEET</label>
                  </b-input-group-prepend>
                  <b-form-input
                    v-model="frmUpload.sheetName"
                    :state="!$v.frmUpload.sheetName.$error"
                  ></b-form-input>
                </b-input-group>
              </b-col>
              <b-col lg="5">
                <b-input-group>
                  <b-input-group-append>
                    <label class="input-group-text ml-1"
                      >Data mulai baris ke-</label
                    >
                  </b-input-group-append>
                  <b-form-input
                    v-model="frmUpload.startRow"
                    type="number"
                    :state="!$v.frmUpload.startRow.$error"
                  ></b-form-input>
                </b-input-group>
              </b-col>
              <b-col lg="12">
                <b-alert :show="showLabelError" variant="danger" class="mt-4">
                  <span v-if="labelErrorTxt != ''">{{ labelErrorTxt }}</span>
                  <b-list-group
                    flush
                    v-if="errorList && errorList.length > 0"
                    style="max-height: 280px; overflow-x: auto"
                  >
                    <b-list-group-item
                      v-for="(item, index) in errorList"
                      :key="index"
                      >Baris : {{ item.baris }}, Kolom : {{ item.kolom }} ,
                      Kesalahan : {{ item.message }}</b-list-group-item
                    >
                  </b-list-group>
                </b-alert>
              </b-col>
            </b-row>
          </div>
          <div v-else>
            <h6 class="text-center">Proses migrasi data angsuran</h6>
            <b-progress :max="100" animated>
              <b-progress-bar :value="progressMigrationAngs.value"></b-progress-bar>
              <b-progress-bar :value="100-(progressMigrationAngs.value)" variant="warning" :animated="false"></b-progress-bar>
            </b-progress>
            <h6 class="text-center">{{((progressMigrationAngs.value / 100) * 100).toFixed(2)}}%</h6>

          </div>
          <div slot="footer" class="text-center" v-if="!showProgressMigration">
            <b-button variant="primary" @click="importmigrationdata()"
              >Import</b-button
            >
            <b-button variant="danger" @click="close()">Close</b-button>
          </div>
        </b-card>
      </b-col>
    </b-row>
    <b-modal
      id="modal-prevent-closing"
      ref="modal"
      title="Konfirmasi"
      v-model="confirmCancel"
      @ok="handleCancel"
    >
      <p class="my-2">Apakah anda yakin?</p>
    </b-modal>
    <loading
      :active.sync="isLoading"
      :height="128"
      :width="128"
      color="#4b8cf4"
    ></loading>
  </div>
</template>

<style lang="scss" scoped>
.upload-prk {
  iframe {
    border: 1px solid #ccc;
    width: 100%;
    height: 11in;
  }
  .ColsDefine {
    .input-group {
      .input-group-prepend {
        label {
          width: 135px !important;
        }
      }
    }
  }
}
</style>

<script>
import moment from "moment";
// import arreport from "../../apis/arreport";
import myNumber from "../../components/my-number";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import toastr from "mini-toastr";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import klmXls from "../../data/kolomXls";
import migration from "../../apis/migration";
import uploadSet from "../../apis/uploadsetting";
toastr.init();

export default {
  mixins: [validationMixin],
  validations: {
    frmUpload: {
      sheetName: { required },
      startRow: { required },
    },
    fileXlsx: { required },
  },
  data() {
    return {
      showUploadFrm: true,
      showProgressMigration: false,
      fileXlsx: null,
      frmUpload: {
        sheetName: "ANGSURAN",
        startRow: 10,
        no: 'A',
        compcode: "B",
        no_kontrak: "C",
        angsuran_ke: "D",
        tgl_jttempo: "E",
        nilai_pokok: "F",
        nilai_bunga: "G",
        nilai_bunga_od: "H",
        angsuran: "I",
        akum_pokok: "J",
        sisa_pokok: "K",
        total_denda: "L",
        settle_pokok: "M",
        settle_bunga: "N",
        settle_denda: "O",
        outstand_pokok: "P",
        outstand_bunga: "Q",
        outstand_denda: "R",
      },
      showLabelError: false,
      errorList: [],
      labelErrorTxt: "",
      kolomXls: klmXls,
      isLoading: false,
      rptLines: [],
      subtotal: {
        sum_settle_pokok: 0,
        sum_settle_bunga: 0,
        sum_settle_denda: 0,
        sum_outstand_pokok: 0,
        sum_outstand_bunga: 0,
        sum_outstand_denda: 0,
      },

      filterShow: "Show",
      tblLcy: {
        page: 1,
        limit: 15,
        total: 0,
        sortBy: null,
        sortDesc: false,
        fields: [
          {
            key: "error_text",
            label: "",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true,
          },
          {
            key: "no",
            label: "No.",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true,
          },
          {
            key: "compcode",
            label: "Kode Entitas",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true,
          },
          {
            key: "no_kontrak",
            label: "No. Kontrak",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true,
          },
          {
            key: "angsuran_ke",
            label: "Angsuran Ke-",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true,
          },
          {
            key: "tgl_jttempo",
            label: "Tgl Jttempo",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true,
          },
          {
            key: "nilai_pokok",
            label: "Principal",
            thClass: "text-center",
            tdClass: "text-right",
            sortable: true,
          },
          {
            key: "nilai_bunga",
            label: "Interest",
            thClass: "text-center",
            tdClass: "text-right",
            sortable: true,
          },
          {
            key: "nilai_bunga_od",
            label: "Interest OD",
            thClass: "text-center",
            tdClass: "text-right",
            sortable: true,
          },

          {
            key: "angsuran",
            label: "Installment",
            thClass: "text-center",
            tdClass: "text-right",
            sortable: true,
          },
          {
            key: "akum_pokok",
            label: "Akum Pokok",
            thClass: "text-center",
            tdClass: "text-right",
            sortable: true,
          },
          {
            key: "sisa_pokok",
            label: "Sisa Pokok",
            thClass: "text-center",
            tdClass: "text-right",
            sortable: true,
          },
          {
            key: "total_denda",
            label: "Total Denda",
            thClass: "text-center",
            tdClass: "text-right",
            sortable: true,
          },
          {
            key: "settle_pokok",
            label: "Settle Pokok",
            thClass: "text-center",
            tdClass: "text-right",
            sortable: true,
          },
          {
            key: "settle_bunga",
            label: "Settle Bunga",
            thClass: "text-center",
            tdClass: "text-right",
            sortable: true,
          },
          {
            key: "settle_denda",
            label: "Settle Denda",
            thClass: "text-center",
            tdClass: "text-right",
            sortable: true,
          },
          {
            key: "outstand_pokok",
            label: "Outstand Pokok",
            thClass: "text-center",
            tdClass: "text-right",
            sortable: true,
          },
          {
            key: "outstand_bunga",
            label: "Outstand Bunga",
            thClass: "text-center",
            tdClass: "text-right",
            sortable: true,
          },
          {
            key: "outstand_denda",
            label: "Outstand Denda",
            thClass: "text-center",
            tdClass: "text-right",
            sortable: true,
          },
        ],
      },
      filter: null,
      filterOn: [],
      saveEnabled: false,
      confirmCancel: false,
    };
  },
  components: { Loading, myNumber },
  computed: {
    invalidFrmUpload() {
      this.$v.frmUpload.$touch();
      return this.$v.frmUpload.$invalid;
    },
    invalidFileXlsx() {
      this.$v.fileXlsx.$touch();
      return this.$v.fileXlsx.$invalid;
    },
    progressMigrationAngsTemp() {
      return this.$store.state.progressMigrationAngsTemp;
    },
    progressMigrationAngs() {
      return this.$store.state.progressMigrationAngs;
    },
  },
  watch: {
    progressMigrationAngsTemp(val) {
      if (val.status == "Idle") {
        this.showProgressMigration = false;
      }

      if (val.status == "Running") {
        this.showProgressMigration = true;
      }

      if (val.status == "Finish") {
        this.showProgressMigration = false;
        toastr.success("Data selesai dibaca", "", 10000);
      }
      if (this.$refs.tableangsuran) {
        this.$refs.tableangsuran.refresh();
      }
    },
    progressMigrationAngs(val) {
      if (val.status == "Idle") {
        this.showProgressMigration = false;
      }
      if (val.status == "Running") {
        this.showProgressMigration = true;
      }
      if (val.status == "Finish") {
        this.showProgressMigration = false;
        toastr.success("Migrasi data telah berhasil", "", 10000);
        this.handleCancel();
      }
    }
  },
  created: async function () {
    let getgroupmigrationkey = localStorage.getItem(
      "groupmigrationangsurankey"
    );
    // let getSheetName = localStorage.getItem("sheetName");
    if (getgroupmigrationkey) {
      this.showUploadFrm = false;
      this.saveEnabled = true;
      if (this.$refs.tableangsuran) {
        this.$refs.tableangsuran.refresh();
      }
    }
    // Get setting field from DB
    const setting = await uploadSet.get("upload_migrationangsuran");
    for (const key in setting) {
      this.frmUpload[key] = setting[key];
    }

    if (this.$store.state.progressMigrationAngsTemp.status == "Idle") {
      this.showProgressMigration = false;
    }
  },
  methods: {
    rowClass(item, type) {
      if (item.error_text == "" || item.error_text == null) {
        return;
      }
      return "table-warning";
      // if (!item || type !== 'row') return
      // if (item.status === 'awesome') return 'table-success'
    },
    async data() {
      this.isLoading = true;
      let getgroupmigrationkey = localStorage.getItem(
        "groupmigrationangsurankey"
      );
      let getSheetName = localStorage.getItem("sheetName");
      if (getgroupmigrationkey) {
        this.showUploadFrm = false;
        this.saveEnabled = this.progressMigrationAngsTemp.status == "Finish" || this.progressMigrationAngsTemp.status == "Idle"?true:false;
        this.tblLcy.groupmigrationkey = getgroupmigrationkey;
        this.tblLcy.sheetName = getSheetName || "ANGSURAN";
        this.tblLcy.sortDir = this.tblLcy.sortDesc ? "desc" : "asc";
        let { list, count } = await migration.getmigrationTEMP(this.tblLcy);
        if (list.length == 0) {
          this.showUploadFrm = true;
          localStorage.removeItem("groupmigrationkey");
          localStorage.removeItem("sheetName");
        }
        const subtotal = {};
        for (const key in count) {
          subtotal[key] = count[key];
        }
        this.subtotal = subtotal;
        this.isLoading = false;
        return list;
      }
      this.isLoading = false;
      return [];
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.tblLcy.total = filteredItems.length;
      this.tblLcy.page = 1;
    },
    clearFilter() {
      this.filterOn = [];
      this.filter = "";
    },
    async importmigrationdata() {
      if (this.invalidFileXlsx || this.invalidFrmUpload) {
        toastr.error("Please fill the form correctly.");
      } else {
        try {
          this.isLoading = true;
          const {
            list,
            groupmigrationkey,
          } = await migration.savemigrationangsuranTEMP(
            this.fileXlsx,
            this.frmUpload
          );
          // this.saveEnabled = result.filter((x) => x.error == true).length == 0;
          localStorage.setItem("groupmigrationangsurankey", groupmigrationkey);
          localStorage.setItem("sheetName", "ANGSURAN");
          toastr.success("Background Service Data Migration Started");
          const this_ = this;
          setTimeout(function(){
            this_.isLoading = false;
            this_.showUploadFrm = false;
            this_.showProgressMigration = true;
            this_.saveEnabled=false;
          },1000)
        } catch (error) {
          this.isLoading = false;
          if (error.errSheetList || error.message) {
            this.showLabelError = true;
            this.labelErrorTxt = error.message;
            this.errorList = error.errSheetList;
            this.fileXlsx = null;
          } else {
            toastr.error(JSON.stringify(error));
          }
        }
      }
    },
    async savemigrationdata() {
      if (this.tblLcy.total == 0) {
        toastr.warn("Data is empty");
        this.saveEnabled = false;
      } else {
        try {
          this.$store.commit('progressMigrationAngs',{ status: 'Idle', value:0 });
          // this.isLoading = true;
          let groupmigrationkey = localStorage.getItem(
            "groupmigrationangsurankey"
          );
          await migration.savemigrationangsuran(groupmigrationkey);
          // localStorage.removeItem("groupmigrationangsurankey");
          // localStorage.removeItem("sheetName");
          toastr.success("Background Service Data Migration Started");
          // this.isLoading = false;
          this.showUploadFrm = true;
          this.showProgressMigration = true;
        } catch (error) {
          this.isLoading = false;
          if (error.message) {
            toastr.error(error.message);
          } else {
            toastr.error(JSON.stringify(error));
          }
        }
      }
    },
    close() {
      router.push("home");
    },
    async handleCancel() {
      this.showUploadFrm = true;
      this.rptLines = [];
      await migration.removeDataTEMP({
        tablename: "fin_migration_angsuran",
        groupmigrationkey: localStorage.getItem("groupmigrationangsurankey"),
      });
      localStorage.removeItem("groupmigrationangsurankey");
      localStorage.removeItem("sheetName");
    },
  },
};
</script>
